import type { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";

const moduleSelector = (state: IRootState) => state.location;

export const getLocationOriginPathnameSelector = createSelector(moduleSelector, state => state.originPathname);

export const getLocationOriginSearchSelector = createSelector(moduleSelector, state => state.originSearch);

export const getPrevLocationSelector = createSelector(moduleSelector, state => state.prevLocation);

export const getLocationAppsflyerSourcePropertySelector = createSelector(getPrevLocationSelector, prevLocation =>
    !prevLocation ? 'None' : `${prevLocation.pathname}${prevLocation.search}`,
);

export const getLocationPlatformSelector = createSelector(moduleSelector, state => state.platform);

export const getIsLocationPlatformMobileSelector = createSelector(moduleSelector, state => state.platform === 'mobile');

export const getIsLocationPlatformDesktopSelector = createSelector(moduleSelector, state => state.platform === 'desktop');

export const getIsLocationInitedSelector = createSelector(moduleSelector, state => state.isInited);
